// Singapore GST tax category codes for PINT-SG (InvoiceNow / IRAS).
// Mirrors the backend mapping in irsp-ubl-builder.service.ts (mapTaxTypeToCategory).
// Reference: https://docs.peppol.eu/poac/sg/pint-sg/trn-invoice/codelist/Aligned-TaxCategoryCodes/
//
// Used only for Singapore Peppol tenants. Malaysia/LHDN tenants continue to use
// @/constants/lhdn/tax-types, so this has no effect on the LHDN experience.
export const sgTaxCategories = [
  { key: 'SR', label: 'Standard Rate (9%)' },
  { key: 'ZR', label: 'Zero Rate (0%)' },
  { key: 'ES33', label: 'Exempt (Regulation 33)' },
  { key: 'ESN33', label: 'Exempt (Not Regulation 33)' },
  { key: 'OS', label: 'Out of Scope' },
  { key: 'DS', label: 'Deemed Supplies' },
  { key: 'NG', label: 'Non-GST Registered' },
  { key: 'SRCA-S', label: 'Standard Rate Customer Accounting (Supplier)' },
  { key: 'SRCA-C', label: 'Standard Rate Customer Accounting (Customer)' },
  { key: 'SRRC', label: 'Standard Rate Reverse Charge' },
  { key: 'SROVR', label: 'Standard Rate Overseas Vendor Registration' },
]
